// extracted by mini-css-extract-plugin
export default {"container":"YD-z","disabled":"ZD-z","bgBlack":"_D-z","content":"aE-z","countdown":"bE-z","topCaption":"cE-z","topHeading":"dE-z","heading":"eE-z","copy":"fE-z"};